import { Typography } from '../../interfaces';

const typography: Typography = {
  fontWeight: {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 700,
    extraBold: 800,
  },
};

export { typography };
